import { useEffect, useState } from 'react'
import { Button, Dialog, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { v4 as uuidv4 } from 'uuid'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import LikertScale from 'components/molecules/LikertScale'
import congratulations from 'assets/images/congratulations.svg'
import { postRequest } from 'utils/api'
import { GOAL_STEP_USER_FEEDBACK_URL } from 'services/constants'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import ImageContainer from 'components/atoms/container/ImageContainer'

const StepFeedbackPopup = ({ l2StepData, organizedSteps, onClose, open }) => {
  const { t } = useTranslation()
  const [l1StepName, setL1StepName] = useState('')

  const options = [...Array(5).keys()].map(k => ({
    value: k + 1,
    labelKey: `constants.likertScaleOptions.${k}`
  }))

  const findL1Step = () => {
    const sortedSteps = [...organizedSteps].sort((a, b) => b.number - a.number)
    const currentL1Step = sortedSteps.find(
      l1Step => l1Step.number < l2StepData.number
    )
    return currentL1Step
  }

  useEffect(() => {
    if (open && organizedSteps && l2StepData) {
      const currentL1Step = findL1Step()
      setL1StepName(currentL1Step?.name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const submitRating = async rating => {
    const requestBody = {
      checkInScore: rating
    }
    const l1Step = findL1Step()
    await postRequest(
      GOAL_STEP_USER_FEEDBACK_URL.replace('{goal_step_id}', l1Step.id),
      requestBody
    )
  }

  const handleContinueClick = () => {
    onClose()
  }

  return (
    <Dialog open={open} maxWidth='xl'>
      <InCardStack spacing={8} sx={{ paddingY: 20, paddingX: 12 }}>
        <ImageContainer src={congratulations} size={120} />
        <Typography variant='h2' color={colors.MidnightTeal400}>
          {t('pathsAndModels.congratulations')}!
        </Typography>
        <Typography color={colors.MidnightTeal400}>
          {t('pathsAndModels.youFinishedThe', {
            l1StepName
          })}
        </Typography>

        <BoxWithBackground
          padding={12}
          backgroundColor={colors.MetalGrey50}
          width={600}>
          <InCardStack spacing={16}>
            <Typography variant='h4' color={colors.MidnightTeal400}>
              {t('stepFeedback.EnjoyedLearningAbout')} {l1StepName}
            </Typography>
            <LikertScale
              id={uuidv4()}
              onChange={v => {
                submitRating(v)
              }}
              options={options}
              setValueFromOthers={true}
              paddingSX={{ paddingX: 5, paddingY: 0, height: 'auto' }}
              containerSx={{
                width: '100%',
                backgroundColor: colors.MetalGrey50
              }}
            />
            <Button onClick={() => handleContinueClick()}>
              {t('common.continue')}
            </Button>
          </InCardStack>
        </BoxWithBackground>
      </InCardStack>
    </Dialog>
  )
}

export default StepFeedbackPopup
